



















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import { TemplateResource } from "@/store/template/types";
import { DataOptions } from "vuetify";
import { Pagination } from "@/store";

@Component({
  components: {
    BaseView
  }
})
export default class TemplateList extends Vue {
  //
  readonly store = this.$store.direct;
  readonly title = "Plantillas";
  readonly subtitle = "Lista todas las plantillas definidas en el sistema";
  readonly info = null;
  // Component properties
  loading: boolean = false;

  get options() {
    return this.store.getters.options;
  }

  set options(val: DataOptions) {
    this.store.commit.SET_PAGINATION_FROM_DATA_OPTIONS(val);
  }

  get pagination() {
    return this.store.state.pagination;
  }

  get totalItems() {
    return this.store.state.totalItems;
  }

  get open() {
    return this.selected != "";
  }

  set open(val: boolean) {
    if (!val) this.selected = "";
  }

  openRemove(val: string) {
    this.selected = val;
  }

  selected: string = "";

  headers = [
    {
      text: "#",
      align: "left",
      sortable: false
    },
    {
      text: "Nombre",
      value: "name",
      align: "center"
    },
    {
      text: "Descripción",
      value: "description",
      align: "center"
    },
    {
      text: "# Solicitudes",
      align: "center",
      sortable: false
    },
    {
      text: "Acciones",
      align: "center",
      sortable: false
    }
  ];

  get templates() {
    return this.store.getters.template.templates;
  }

  refresh() {
    this.store.dispatch.template.get();
  }

  create() {
    this.store.commit.template.CLEAR_SELECTED();
    this.$router.push("/templates/new");
  }

  detail(template: TemplateResource) {
    this.$router.push("/templates/" + template.id);
  }

  async destroy(id: string) {
    let res = await this.store.dispatch.template.delete(id);
    if (res.data) {
      this.store.commit.PUSH_MESSAGE({
        message: "La plantilla ha sido eliminada",
        type: "success"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La plantilla no se ha podido eliminar. Intente nuevamente.",
        type: "error"
      });
    }
    this.open = false;
  }

  mounted() {
    this.refresh();
  }

  @Watch("pagination", { deep: true })
  handleOptionsChange(newVal: Pagination, oldVal: Pagination) {
    if (
      this.store.state.totalItems != undefined &&
      (newVal.page != oldVal.page ||
        newVal.itemsPerPage != oldVal.itemsPerPage ||
        newVal.sortBy != oldVal.sortBy ||
        newVal.sortDesc != oldVal.sortDesc)
    ) {
      this.store.dispatch.template.get();
    }
  }
}
